export default "__VITE_ASSET__Ccv7wHup__"